import { Box } from '@mui/material';

import LocalImage from '../../../../../components/LocalImage';

const BackSlider = ({ isWebviewVersion }) => {
  const randomIndex = Math.floor(Math.random() * 10 + 1);

  return (
    <Box
      sx={{
        backgroundColor: '#141516',
        display: 'flex',
        justifyContent: { xs: 'center', lg: 'flex-end' },
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
        position: 'absolute',
        overflow: 'hidden',
        height: { xs: '80%', tl: '100%' },
        left: 0,
        bottom: 0,
        right: 0,
        top: isWebviewVersion ? 0 : { xs: 48, tl: 0 },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '100%', lg: 'auto' },
          height: { xs: 160, tl: 'auto' },
        }}
      >
        <LocalImage
          src={`img/top-banner/background-images/${randomIndex}.webp`}
          alt=""
          loading="lazy"
        />
        <Box
          sx={{
            background: {
              xs: 'linear-gradient(360deg, #151617 0%, rgba(21, 22, 23, 0.64) 100%)',
              tl: 'linear-gradient(90deg, #151617 1%, rgba(21,22,23,0.64) 100%)',
            },
            position: 'absolute',
            overflow: 'hidden',
            width: '100%',
            height: '100%',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0,
          }}
        />
      </Box>
    </Box>
  );
};

export default BackSlider;
